module.exports = __webpack_public_path__ + "static/img/Kurt-Capewell.25303cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kurt-Capewell.jpg
// module id = R2B4
// module chunks = 0